<div class="row" style="margin-top:50px;padding:5px">
    <div class="container">
        <div id="summary-container">
            <div class="row">
                <div *ngIf="!isMobile" class="col-lg-6">
                    <img src="../../assets/email.png" width="80%;">
                </div>
                <div class="col-lg-6" style="display:flex;flex-direction: column;justify-content: space-between;">
                    <div>
                        <form [formGroup]="form">
                            <p class="title-6" style="margin-bottom: 40px;">If you'd like a copy of these results, you can enter your email below and we'll send them over.</p>
                            <div class='input-section'>
                                <p class="title-4">Email Address</p>
                                <div class="input-container">
                                    <input
                                    placeholder="@"
                                    formControlName="email"
                                    type="email">
                                </div>
                            </div>
                            <div class='input-section'>
                                <p class="title-4">Initial Term End Date</p>
                                <div class="input-container">
                                    <input
                                    name="date"
                                    formControlName="date"
                                    type="date">
                                </div>
                            </div>
                            <p class="title-5">Already have a mortgage? We can remind you when it’s time to start thinking about switching to a better deal. We may even have some extra special offers for you, from our lending partners!</p>
                            <mat-checkbox
                                formControlName="reminder"
                                style="display: flex;flex-direction: row;justify-content: start;"
                                class="example-margin"
                                [labelPosition]="'right'">
                                Yes, remind me
                            </mat-checkbox>
                        </form>
                    </div>
                    <div>
                        <div style="display: flex;flex-direction: row;justify-content:flex-end">
                            <button *ngIf="loading" class="submit-button"><fa-icon [icon]="faSpinner" spin="true"></fa-icon></button>
                            <button *ngIf="!loading" (click)="submit()" class="submit-button">Submit</button>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>